import * as React from 'react';
import { mergeProps, useObjectRef } from 'react-aria';

import { Button, type ButtonProps } from '@gitbook/spine-react';

import { type UsePaletteTriggerProps, usePaletteTrigger } from './PaletteTrigger';

/**
 * Button that opens a palette when pressed.
 */
export const PaletteButton = React.forwardRef(function PaletteButton(
    props: Omit<ButtonProps, 'onPress'> & Omit<UsePaletteTriggerProps, 'ref'>,
    forwardedRef: React.Ref<HTMLButtonElement>
) {
    const { palette, ...otherButtonProps } = props;
    const ref = useObjectRef(forwardedRef);
    const { triggerProps, opened } = usePaletteTrigger({
        ref,
        palette,
        isDisabled: props.disabled,
    });

    return (
        <Button
            onClick={(e) => e.preventDefault()}
            active={opened}
            {...mergeProps(triggerProps, otherButtonProps)}
        />
    );
});
